import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
import { AuthService } from '../auth.service';
import { Router, ActivatedRoute} from '@angular/router';
import { AlertService} from '../../shared/alert.service';
import { FormsService } from '../../shared/forms.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  loginError: string;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private alertService: AlertService,
    public formsService: FormsService) {
    this.createFormGroup();
  }

  ngOnInit() {
    if (this.authService.isAuthenticated()) {
      this.router.navigate(['/']);
    }
  }

  login() {
    this.authService.login(this.loginForm.value.email, this.loginForm.value.password)
      .subscribe(result => {
        if (result === true) {
          const redirect: string = this.authService.redirectUrl || '/';
          // Redirect the user
          this.router.navigate([redirect]);

        } else {
          this.alertService.error('Hubo un error en el inicio de sesión');
          this.loginError = 'Username or password is incorrect';
        }
      },
      error => {
        const errorJson = error.json();
        this.alertService.error(errorJson.message);
      });
  }

  hasError(field: string): boolean {
    return this.formsService.hasError(this.loginForm, field);
  }

  hasSpecificError(field: string, validator: string): boolean {
    return this.formsService.hasSpecificError(this.loginForm, field, validator);
  }

  private createFormGroup() {
    this.loginForm = this.fb.group({
      'email' : [
        null,
        Validators.compose([
          Validators.required,
          Validators.email
        ])
      ],
      'password' : [
        null,
        Validators.required
      ]
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/auth/login/login.component.ts